export const LIST_NAME = `planTypeEventType`
export const getBasicUrl = planTypeId =>
  `/plan/types/${planTypeId}/events/types`
